import { styled } from '@mui/material';

export type StyledOptionProps = {
  selectedItemsOnTop?: boolean;
};

export const StyledOption = styled('li')<StyledOptionProps>(({ theme, selectedItemsOnTop }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',

  // Styles of label in option
  '& > label': {
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
  },

  // Override Mui-selected background only when selectedItemsOnTop is true
  ...(selectedItemsOnTop && {
    '&.MuiAutocomplete-option[aria-selected="true"]': {
      backgroundColor: 'transparent !important',

      '&:hover': {
        backgroundColor: `${theme.palette.action.hover} !important`,
      },
    },
  }),
}));
